/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 13:58:40
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-28 09:23:46
 * @Description: file content
 */

export default {
  appid: "",
  protocol: "",
  domain: "",
  openid: "",// 私有
  action: {
    getUserInfo: "/circle-act-game-assistance/act/m/web/getUserInfo",
    getSignature: "/circle-act-game-assistance/act/m/web/getJsapiSignature",
    auth: "/circle-act-game-assistance/act/m/web/userAuth",
    wxWorkauth: "qc-webapp/qywx/auth/web/getAuthUrl",
    wxWorkGetUserInfo: "qc-webapp/user/account",
    wxWorkGetUserInfoImg: "qc-webapp/m/qw/user/info",
    getWxWorkSignature: "qc-webapp/qywx/getCorpSignature",
    getCorpAgentSignature: "qc-webapp/qywx/getCorpAgentSignature",
  }
}